import { useState } from 'react';
import groupAvatar from "../images/group_avatar.png"
import kitcut from "../utils/kitcut";

export const AvatarBlock = (props) => {
  const [imgError, setImgError] = useState(false);
  const item = props.item ?? { image: null, name: null }
  const groupItem = props.groupItem ?? null;
  const hasName = props.hasName ?? item.name !== null ? true : false;
  const isGroup = props.isGroup ?? false;

  let component =
    <>
      <div className={props.className + "__img"}>
        {
          (isGroup || !item.name)
            ? <img src={'' + groupAvatar + ''} alt="" title="" />
            : (item.image == null || imgError)
              ? <div className={props.className + "__defimg"}>{item.name != null && item.name.substr(0, 1)}</div>
              : <img src={'' + item.image + ''} alt="" title="" onError={() => setImgError(true)} />
        }
      </div>
      {
        hasName &&
        <div className={props.className + "__name"}>
          {
            item.name != null && groupItem ? kitcut(item.name, 15) : item.name
          }
        </div>
      }
    </>
  if (item.name && groupItem)
    component =
      <a href={"https://www.instagram.com/" + item.name + "/"} className={props.className + "__link"}>
        {component}
      </a>

  if (groupItem)
    component =
      <div className={props.className + "__group_item"}>
        {component}
      </div>
  return component;
}